import { Configuration, PublicClientApplication, RedirectRequest  } from "@azure/msal-browser";
//import { Configuration, PublicClientApplication, EventType, EventMessage, AuthenticationResult, InteractionType, InteractionRequiredAuthError, RedirectRequest  } from "@azure/msal-browser";

//import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from "@azure/msal-react";




import { httpInstance } from './core';




export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',

    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`, // 'https://login.microsoftonline.com/common'

    // navigateToLoginRequestUrl: true,


    // TODO: https://learn.microsoft.com/en-gb/azure/active-directory/develop/reply-url
    redirectUri: window.location.href // process.env.REACT_APP_REDIRECT_URI || '/'
    // TODO: redirect using state
  }
};



export const msalInstance = new PublicClientApplication(msalConfig);







// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: [ 'User.Read' ],
  // state: `redirect=${window.location.href}`
  // TODO: https://learn.microsoft.com/en-us/azure/active-directory/develop/msal-js-pass-custom-state-authentication-request
  // TODO: redirect using state
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


















export async function callMsGraph() {

  const account = msalInstance.getActiveAccount();

  if (account) {

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    const r = fetch(graphConfig.graphMeEndpoint, options)
      .then(response => response.json())
      .catch(error => console.log(error));

    const rr = await r;

    console.log(rr);

    return r;

  } else {
    // throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    console.error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
    return undefined;
  }
}






export const getCurrentAccountFromGraph = async () => {

  try {
    const account = msalInstance.getActiveAccount();

    if (account) {

      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
      });

      // console.log(account);

      // return account;




      const headers = new Headers();
      const bearer = `Bearer ${response.accessToken}`;

      headers.append("Authorization", bearer);

      const options = {
          method: "GET",
          headers: headers
      };

      const r = fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));

      const rr = await r;

      console.log(rr);

      return r;




    } else {
      // throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      console.error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
    }

  } catch (error) {

    console.log(error);

    return undefined;
  }

};




httpInstance.interceptors.request.use(async (config: any) => {
  // console.log('httpInstance.interceptor');

  try {
    const account = msalInstance.getActiveAccount();

    if (account) {

      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
      });

      const bearer = `Bearer ${response.accessToken}`;

      config.headers['wsp-token'] = bearer;
      config.headers['Authorization'] = bearer;
      config.headers['eg-user-id'] = account.localAccountId;

    } else {
      // throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      console.error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
    }

  } catch (error) {
    console.log(error);
  }

  return config;
});







export const user = {
  id:        0,
  guid:     '',
  name:     '',
  role:     { id: 0 },
  account:  '',
  email:    '',
  testUser: ''
};

export const loadApi = async (route: string, method?: string, payload?: any, uploadFile?: boolean): Promise<any> => {
  console.log("loadApi: ", route);

  let r = null;

  try {
    const account = msalInstance.getActiveAccount();

    if (account) {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
      });

      console.log('Account: ', account);

      const bearer = `Bearer ${response.accessToken}`;      
      const headers = {
        'accept': 'application/json',
        'eg-user-id': account.localAccountId,
        'wsp-token': bearer
      };
  
      const options = {
        headers: headers,
        method: 'get'
      };

      if (method) {
        options.method = method;

        if (payload) {
          if (uploadFile) {
            options['body'] = payload;
          } else {
            options.headers['content-type'] = 'application/json';
            options['body'] = JSON.stringify(payload);
          }
        }
      }

      await fetch( process.env.REACT_APP_WSP_API_BASE_URL + '/api' + route, options)
      .then(res => res.json())
      .then(
        (result: any) => {
          r = result;
        },
        (error: any) => {
          console.error(error);
          r = error;
        }
      );

      return r;

    } else {
      // throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      console.error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
    }

  }
  catch (error) {
    console.log(error);
    return undefined;
  }
}


export const loadA365 = async (route: string, payload: any): Promise<any> => {
  return undefined;
}



// msalInstance.handleRedirectPromise().then((tokenResponse) => {
//   // Check if the tokenResponse is null
//   // If the tokenResponse !== null, then you are coming back from a successful authentication redirect. 
//   // If the tokenResponse === null, you are not coming back from an auth redirect.
// }).catch((error) => {
//   // handle error, either in the library or coming back from the server
// });


// In certain cases, the `acquireTokenSilent` method's attempt to get the token silently fails.
// Some examples of this are when there is an expired user session with Azure AD or a password change by the user, etc. which requires user interaction.
// When the `acquireTokenSilent` fails, you need to call one of the interactive acquire token methods (`acquireTokenPopup` or `acquireTokenRedirect`).






// const request = {
//   loginHint: "name@example.com",
//   scopes: ["User.Read"]
// }

// const { login, result, error } = useMsalAuthentication(InteractionType.Silent, request);

// useEffect(() => {
//   if (error instanceof InteractionRequiredAuthError) {
//       login(InteractionType.Popup, request);
//   }
// }, [error]);

// const { accounts } = useMsal();
